// extracted by mini-css-extract-plugin
module.exports = {"hidden":"emptyContents_hidden__P3re1","textEmphasis":"emptyContents_textEmphasis__TelPo","area":"emptyContents_area__ZlSRr"};